"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Export = function Export() {
  return _react2.default.createElement(
    "g",
    { id: "export" },
    _react2.default.createElement("path", {
      d: "M161.166667,382.416667 L339.5,382.416667 L339.5,205.833333 L458.666667,205.833333 L250.333333,0 L42,205.916667 L161.166667,205.916667 L161.166667,382.416667 L161.166667,382.416667 L161.166667,382.416667 Z M42,441.25 L458.666667,441.25 L458.666667,500 L42,500 L42,441.25 L42,441.25 Z",
      id: "Shape"
    })
  );
};

exports.default = Export;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Export.js
// module id = 2946
// module chunks = 4